// @flow
import React, { type Node, useContext } from 'react';

import { AlternativeDateSuggestionImmersive } from 'Components/widgets/alternative-proposals/alternative-date-suggestion/AlternativeDateSuggestionImmersive';
import ResponsiveContext from 'Components/utils/responsive/responsiveContext';
import { Scrollable } from 'Components/frameworks/scrollable/Scrollable';

type Props = {|
  title: string,
  children: Node,
  onClose?: () => void,
  immersiveResort?: $ReadOnly<{
    name: string,
    image?: string,
  }>,
|};

export const AlternativeSuggestions = ({ title, children, onClose, immersiveResort }: Props) => {
  const { isBrowserGreaterThan } = useContext(ResponsiveContext);

  return (
    <div className="AlternativeProposalsModal-content-wrapper w-full flex flex-col md:flex-row justify-center mt-4">
      <div className="AlternativeProposalsModal-date-suggestion flex flex-col sm:flex-row w-full">
        <div className="AlternativeProposalsModal-contentCriterias mb-10 md:mb-0 md:mt-8 lg:ml-6">
          <div className="AlternativeProposalsModal-titleSuggest text-blue text-xl font-bold px-6 lg:pl-0">
            {title}
          </div>
          {isBrowserGreaterThan.S ? (
            <div className="AlternativeProposalsModal-Criterias md:flex md:flex-wrap">
              {children}
            </div>
          ) : (
            <Scrollable
              additionalClass="AlternativeProposalsModal-SwipeableScrollview"
              childrenWrapperClassNames="flex px-6"
              hasArrows={false}
            >
              {children}
            </Scrollable>
          )}
        </div>
        {immersiveResort && (
          <AlternativeDateSuggestionImmersive onClose={onClose} resort={immersiveResort} />
        )}
      </div>
    </div>
  );
};
